export default "__VITE_ASSET__7c7d4acc__"